import { FieldPath } from 'react-hook-form';
import { ItemDetailsFormData } from './types';

export const attributesToField: Record<
  string,
  FieldPath<ItemDetailsFormData>
> = {
  detail_3: 'detail1',
  detail_1: 'detail2',
  detail_2: 'detail3',
  pattern_print: 'patternPrint',
  fabric: 'fabric',
  wash: 'wash',
  neckline: 'neckline',
  sleeve_length: 'sleeveLength',
  top_length: 'topLength',
  body_fit_top: 'bodyFitTop',
  body_fit_bottom: 'bodyFitBottom',
  bottom_length: 'bottomLength',
  heel_height: 'heelHeight',
  heel_type: 'heelType',
  shoe_style: 'shoeStyle',
};
